import { ReactNode } from 'react';
import './Card.css';

interface CardProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'newspaper' | 'elevated' | 'editorial';
  padding?: 'sm' | 'md' | 'lg' | 'xl';
}

export function Card({
  children,
  className = '',
  variant = 'editorial',
  padding = 'lg'
}: CardProps) {
  const baseClasses = 'card';
  const variantClasses = `card--${variant}`;
  const paddingClasses = `card--padding-${padding}`;

  const allClasses = [
    baseClasses,
    variantClasses,
    paddingClasses,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={allClasses}>
      {children}
    </div>
  );
}
